import { useTranslation } from 'react-i18next';

import type { MouseEvent } from 'react';
import type { PlanningEntityType } from 'generated/index';

import {
  EntitySearchFilterContainer,
  FilterChip
} from 'components/mrp/components/EntitySearch/components/EntitySearchFilter/EntitySearchFilter.styles';

import type { PlanningEntityTypeFilterProps } from './PlanningEntityTypeFilter.types';

/** The type chips under the search field, styled as EntitySearch's: Alle · Patiënten · … · Planeenheden. */
const PlanningEntityTypeFilter = ({
  showAll,
  types,
  activeFilter,
  onSelectType
}: PlanningEntityTypeFilterProps) => {
  'use memo';

  const { t } = useTranslation('common', { keyPrefix: 'mrp' });

  // Kept from reaching the Autocomplete, as EntitySearch's chips are.
  const handleSelect = (
    event: MouseEvent<HTMLElement>,
    type: PlanningEntityType | null
  ) => {
    event.preventDefault();
    event.stopPropagation();
    onSelectType(type);
  };

  if (!showAll && types.length === 0) return null;

  return (
    <EntitySearchFilterContainer>
      {showAll && (
        <FilterChip
          label={t('all')}
          onClick={(event) => handleSelect(event, null)}
          variant={activeFilter.length === 0 ? 'filled' : 'outlined'}
        />
      )}
      {types.map((type) => (
        <FilterChip
          key={type}
          label={t(`entityTypeMap.${type}.plural`)}
          onClick={(event) => handleSelect(event, type)}
          variant={activeFilter.includes(type) ? 'filled' : 'outlined'}
        />
      ))}
    </EntitySearchFilterContainer>
  );
};

export default PlanningEntityTypeFilter;
